import {fabric} from 'fabric';
import {useEffect} from 'react';

export const useImageSizeLimits = (canvas, {min, max}) => {
  useEffect(() => {
    if (!canvas) return;

    const enforceSizeLimits = (obj) => {
      if (!obj || obj.type !== 'uYOImage' || !obj._originalElement) return;

      const originalScale = fabric.util.findScaleToCover(obj, obj._originalObject);
      const currentScale = obj.scaleX / originalScale;

      if (currentScale < min) {
        const newScale = originalScale * min;
        obj.set({minScaleLimit: newScale, lockScalingFlip: true});
        obj.scale(newScale);
        canvas.requestRenderAll();
      } else if (currentScale > max) {
        const newScale = originalScale * max;
        obj.scale(newScale);
        canvas.requestRenderAll();
      }
    };

    const handleScaling = (e) => {
      enforceSizeLimits(e.target);
    };

    canvas.on('object:scaling', handleScaling);
    return () => {
      canvas.off('object:scaling', handleScaling);
    };
  }, [canvas, min, max]);

  return null;
};
